export const environment = {
  production: false,
  name: 'mypay4.mywire.org-snapshot',
  baseApiUrl: '/mypay4/snapshot/api/'
};
